/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/sort'
export default icon
